import React from "react";
import "../../stylesheets2025/Author.css";


export default function ConferenceUI() {
    return (
        <div className="containerAuthor">




            {/* Header */}
            <header className="headerAuthor">
                <h1>Call for Papers</h1>
                <p className="tagline">
                    Water, Energy, Waste Management and Climate
                </p>
            </header>


            <div className="form-container flex flex-col md:flex-row justify-center items-center gap-8 mt-10">
                {/* Author Form */}
                {/* <div className="form text-center">
                    <p>Digest Submissions</p>
                    <a
                        href="https://forms.gle/ArPdVFGjiNu3jCRE8"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Digest Submissions Link
                    </a>
                </div> */}

                <p>Submit your paper here: <a href="https://cmt3.research.microsoft.com/SANKET2026" target="_blank" rel="noopener noreferrer">Click Here to Submit</a></p>
                <div className="cmt-acknowledgement">
                    <h3>CMT Acknowledgement</h3>
                    <p>
                        The Microsoft CMT service was used for managing the peer-reviewing process for this
                        conference. This service was provided for free by Microsoft and they bore all expenses
                        and services as well as for software development and support.
                    </p>
                </div>
            </div>
            <p style={{ fontSize: "1.3rem" }}>
                Note: International submissions are welcome. Authors based outside India may
                present accepted papers in hybrid mode (online or onsite).
            </p>

            <div
                style={{
                    marginTop: "20px",
                    padding: "15px",
                    border: "2px solid #28a745",
                    backgroundColor: "#f8fff8",
                    borderRadius: "6px",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    lineHeight: "1.6",
                }}
            >
                All accepted and presented papers will be published as e-proceedings and submitted to the IEEE Xplore Digital Library (indexed in Scopus, Google Scholar, and other major indexes) subject to IEEE's publication requirements, scope, and quality review.
            </div>

            {/* Important Dates */}
            <section className="section">
                <h2>Important Dates</h2>

                <table className="dates-table">
                    <thead>
                        <tr>
                            <th>S. No</th>
                            <th>Details</th>
                            <th>Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Start of  Paper Submission  </td>
                            <td>1st May, 2026 </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Paper Submission Deadline    </td>
                            <td> 30th September, 2026 (Hard Deadline)</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Paper Acceptance Notification </td>
                            <td>15th October, 2026</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Camera-Ready Paper Submission Deadline</td>
                            <td>10th November, 2026</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Early Bird Registration</td>
                            <td>7th November, 2026</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Final Registration Deadline</td>
                            <td>10th November, 2026</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>Conference Date   </td>
                            <td> 4th-5th December 2026 </td>
                        </tr>
                    </tbody>
                </table>
            </section>


            {/* Water */}
            <div className="theme-card">
                <h3>Water</h3>
                <ul>
                    <li>1.1 Surface Aeration Systems</li>
                    <li>1.2 Application of AI & ML for Water Sustainability</li>
                    <li>1.3 Sediment Modelling</li>
                    <li>1.4 Water Treatment</li>
                    <li>1.5 Life Cycle Analysis</li>
                    <li>1.6 Low Cost Wastewater Treatment</li>
                    <li>1.7 Watershed Management</li>
                    <li>1.8 Agricultural Water Management</li>
                    <li>1.9 Ancient Knowledge Systems for Water Sustainability</li>
                </ul>
            </div>

            {/* Energy */}
            <div className="theme-card">
                <h3>Energy</h3>
                <ul>
                    <li>2.1 Solar Renewable Energy Systems</li>
                    <li>2.2 Other Renewable Energy Systems</li>
                    <li>2.3 Smart Grids & Microgrids</li>
                    <li>2.4 Power Converters for Renewables and Electric Vehicles</li>
                    <li>2.5 Green Fuels</li>
                    <li>2.6 Energy Storage Systems</li>
                    <li>2.7 Green Buildings</li>
                    <li>2.8 AI/ML Applications for Energy Sustainability</li>
                    <li>2.9 Ancient Knowledge Systems for Energy Sustainability</li>
                    <li>2.10 Sustainable Construction Materials</li>
                    <li>2.11 Disaster Resilient & Sustainable Infrastructure</li>
                </ul>
            </div>

            {/* Waste Management */}
            <div className="theme-card">
                <h3>Waste Management</h3>
                <ul>
                    <ul>
                        <li>3.1 Circular Economy & Resource Recovery</li>
                        <li>3.2 Plastic & E-Waste Management</li>
                        <li>3.3 Smart Waste Systems</li>
                        <li>3.4 Ancient Knowledge Systems for Waste Management</li>
                        <li>3.5 Sustainable and Circular Textiles</li>
                        <li>3.6 Solid Waste Management</li>
                        <li>3.7 Waste to Wealth Technologies</li>
                        <li>3.8 Wastewater Treatment</li>
                        <li>3.9 AI/ML Applications for Waste Management</li>
                    </ul>
                </ul>
            </div>

            {/* Climate */}
            <div className="theme-card">
                <h3>Climate</h3>
                <ul>
                    <li>4.1 CCUS and CDR</li>
                    <li>4.2 AI/ML Applications for Climate Sustainability</li>
                    <li>4.3 Ancient Knowledge Systems for Climate Sustainability</li>
                    <li>4.4 Climate Policies</li>
                    <li>4.5 Climate Change Impact Assessment</li>
                    <li>4.6 Climate Variability Study</li>
                    <li>4.7 Environmental Impact Assessment</li>
                </ul>
            </div>

            <section className="section">
                <h2>Guidelines for Paper Submission</h2>


                <div className="guidelines-box">


                    <h3>Instructions for paper submission (SANKET 2026)</h3>
                    <ul>
                        <li>
                            Papers can be submitted to any of the relevant <strong>tracks</strong> listed in
                            the Submission Tracks section above.
                        </li>
                        <li>
                            Submit a <strong>PDF File</strong>, not exceeding{" "}
                            <strong>six (6)</strong> A4 pages (maximum file size 3&nbsp;MB). Download the
                            official template from the{" "}
                            <a
                                href="https://www.ieee.org/conferences/publishing/templates"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                IEEE conference publishing templates
                            </a>
                            .
                        </li>
                        <li>
                            Review is <strong>single blind</strong>. Authors should include their names and
                            affiliations in the manuscript.
                        </li>
                        <li>
                            Each paper must include an <strong>abstract</strong> of about 250 words and a
                            maximum of <strong>five keywords</strong>.
                        </li>
                        <li>
                            Submitted papers are checked for plagiarism. Papers with similarity scores of{" "}
                            <strong>20% or above</strong> may be rejected without further review.
                        </li>
                        <li>Review decisions will be communicated to authors by <strong>email</strong>.</li>
                        <li>
                            Authors of accepted papers must revise their manuscripts according to reviewers’
                            comments and submit the <strong>camera-ready</strong> version by the published
                            deadline. <strong>Adding or removing author names</strong> after acceptance is not
                            permitted.
                        </li>
                    </ul>
                </div>
            </section>





        </div>
    );
}


// import React from "react";
// import "../../stylesheets2025/Author.css";


// export default function ConferenceUI() {
//     return (
//         <div className="containerAuthor">




//             {/* Header */}
//             <header className="headerAuthor">
//                 <h1>Call for Papers</h1>
//                 <p className="tagline">
//                     Water, Energy, Waste Management and Climate
//                 </p>
//             </header>


//             <div className="form-container flex flex-col md:flex-row justify-center items-center gap-8 mt-10">
//                 {/* Author Form */}
//                 {/* <div className="form text-center">
//                     <p>Digest Submissions</p>
//                     <a
//                         href="https://forms.gle/ArPdVFGjiNu3jCRE8"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                     >
//                         Digest Submissions Link
//                     </a>
//                 </div> */}

//                 <p>Submit your paper here: <a href="https://cmt3.research.microsoft.com/SANKET2026" target="_blank" rel="noopener noreferrer">Click Here to Submit</a></p>
//                 <div className="cmt-acknowledgement">
//                     <h3>CMT Acknowledgement</h3>
//                     <p>
//                         The Microsoft CMT service was used for managing the peer-reviewing process for this
//                         conference. This service was provided for free by Microsoft and they bore all expenses
//                         and services as well as for software development and support.
//                     </p>
//                 </div>
//             </div>
//             <p style={{ fontSize: "1.3rem" }}>
//                 Note: International submissions are welcome. Authors based outside India may
//                 present accepted papers in hybrid mode (online or onsite).
//             </p>

//             <div
//                 style={{
//                     marginTop: "20px",
//                     padding: "15px",
//                     border: "2px solid #28a745",
//                     backgroundColor: "#f8fff8",
//                     borderRadius: "6px",
//                     fontSize: "1.1rem",
//                     fontWeight: "500",
//                     lineHeight: "1.6",
//                 }}
//             >
//                 All accepted and presented papers will be published as e-proceedings and submitted to the IEEE Xplore Digital Library (indexed in Scopus, Google Scholar, and other major indexes) subject to IEEE's publication requirements, scope, and quality review.
//             </div>

//             {/* Important Dates */}
//             <section className="section">
//                 <h2>Important Dates</h2>

//                 <table className="dates-table">
//                     <thead>
//                         <tr>
//                             <th>S. No</th>
//                             <th>Details</th>
//                             <th>Date</th>
//                         </tr>
//                     </thead>

//                     <tbody>
//                         <tr>
//                             <td>1</td>
//                             <td>Start of  Paper Submission  </td>
//                             <td>1st May, 2026 </td>
//                         </tr>
//                         <tr>
//                             <td>2</td>
//                             <td>Paper Submission Deadline    </td>
//                             <td> 30th September, 2026 (Hard Deadline)</td>
//                         </tr>
//                         <tr>
//                             <td>3</td>
//                             <td>Paper Acceptance Notification </td>
//                             <td>15th October, 2026</td>
//                         </tr>
//                         <tr>
//                             <td>4</td>
//                             <td>Camera-Ready Paper Submission  Deadline </td>
//                             <td>31st October, 2026 </td>
//                         </tr>
//                         <tr>
//                             <td>5</td>
//                             <td>Early Bird Registration  Deadline  </td>
//                             <td>31st October, 2026 </td>
//                         </tr>
//                         <tr>
//                             <td>6</td>
//                             <td>Conference Date   </td>
//                             <td> 4th-5th December 2026 </td>
//                         </tr>
//                     </tbody>
//                 </table>
//             </section>


//             {/* Water */}
//             <div className="theme-card">
//                 <h3>Water</h3>
//                 <ul>
//                     <li>1.1 Surface Aeration Systems</li>
//                     <li>1.2 Application of AI & ML for Water Sustainability</li>
//                     <li>1.3 Sediment Modelling</li>
//                     <li>1.4 Water Treatment</li>
//                     <li>1.5 Life Cycle Analysis</li>
//                     <li>1.6 Low Cost Wastewater Treatment</li>
//                     <li>1.7 Watershed Management</li>
//                     <li>1.8 Agricultural Water Management</li>
//                     <li>1.9 Ancient Knowledge Systems for Water Sustainability</li>
//                 </ul>
//             </div>

//             {/* Energy */}
//             <div className="theme-card">
//                 <h3>Energy</h3>
//                 <ul>
//                     <li>2.1 Solar Renewable Energy Systems</li>
//                     <li>2.2 Other Renewable Energy Systems</li>
//                     <li>2.3 Smart Grids & Microgrids</li>
//                     <li>2.4 Power Converters for Renewables and Electric Vehicles</li>
//                     <li>2.5 Green Fuels</li>
//                     <li>2.6 Energy Storage Systems</li>
//                     <li>2.7 Green Buildings</li>
//                     <li>2.8 AI/ML Applications for Energy Sustainability</li>
//                     <li>2.9 Ancient Knowledge Systems for Energy Sustainability</li>
//                     <li>2.10 Sustainable Construction Materials</li>
//                     <li>2.11 Disaster Resilient & Sustainable Infrastructure</li>
//                 </ul>
//             </div>

//             {/* Waste Management */}
//             <div className="theme-card">
//                 <h3>Waste Management</h3>
//                 <ul>
//                     <ul>
//                         <li>3.1 Circular Economy & Resource Recovery</li>
//                         <li>3.2 Plastic & E-Waste Management</li>
//                         <li>3.3 Smart Waste Systems</li>
//                         <li>3.4 Ancient Knowledge Systems for Waste Management</li>
//                         <li>3.5 Sustainable and Circular Textiles</li>
//                         <li>3.6 Solid Waste Management</li>
//                         <li>3.7 Waste to Wealth Technologies</li>
//                         <li>3.8 Wastewater Treatment</li>
//                         <li>3.9 AI/ML Applications for Waste Management</li>
//                     </ul>
//                 </ul>
//             </div>

//             {/* Climate */}
//             <div className="theme-card">
//                 <h3>Climate</h3>
//                 <ul>
//                     <li>4.1 CCUS and CDR</li>
//                     <li>4.2 AI/ML Applications for Climate Sustainability</li>
//                     <li>4.3 Ancient Knowledge Systems for Climate Sustainability</li>
//                     <li>4.4 Climate Policies</li>
//                     <li>4.5 Climate Change Impact Assessment</li>
//                     <li>4.6 Climate Variability Study</li>
//                     <li>4.7 Environmental Impact Assessment</li>
//                 </ul>
//             </div>

//             <section className="section">
//                 <h2>Guidelines for Paper Submission</h2>


//                 <div className="guidelines-box">


//                     <h3>Instructions for paper submission (SANKET 2026)</h3>
//                     <ul>
//                         <li>
//                             Papers can be submitted to any of the relevant <strong>tracks</strong> listed in
//                             the Submission Tracks section above.
//                         </li>
//                         <li>
//                             Submit a <strong>PDF File</strong>, not exceeding{" "}
//                             <strong>six (6)</strong> A4 pages (maximum file size 3&nbsp;MB). Download the
//                             official template from the{" "}
//                             <a
//                                 href="https://www.ieee.org/conferences/publishing/templates"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                             >
//                                 IEEE conference publishing templates
//                             </a>
//                             .
//                         </li>
//                         <li>
//                             Review is <strong>single blind</strong>. Authors should include their names and
//                             affiliations in the manuscript.
//                         </li>
//                         <li>
//                             Each paper must include an <strong>abstract</strong> of about 250 words and a
//                             maximum of <strong>five keywords</strong>.
//                         </li>
//                         <li>
//                             Submitted papers are checked for plagiarism. Papers with similarity scores of{" "}
//                             <strong>30% or above</strong> may be rejected without further review.
//                         </li>
//                         <li>Review decisions will be communicated to authors by <strong>email</strong>.</li>
//                         <li>
//                             Authors of accepted papers must revise their manuscripts according to reviewers’
//                             comments and submit the <strong>camera-ready</strong> version by the published
//                             deadline. <strong>Adding or removing author names</strong> after acceptance is not
//                             permitted.
//                         </li>
//                     </ul>
//                 </div>
//             </section>





//         </div>
//     );
// }
